module.exports = __webpack_public_path__ + "static/media/logo-m-mahou.5afea978.svg";